import $ from 'jquery';
import EFOcats_settingdata from '../../../core/v1/setting/efocats_settingdata.js';

/**
 * 設定データに関する（処理動作確認用案件）
 */
export default class EFOcats_retro_settingdata extends EFOcats_settingdata {
  get_pages(form) {
    const pages = [];

    const table = $('.table-wrap table');
    const tr = table.find('tr');
    tr.each((index, elem) => {
      if ($(elem).find('th').html().indexOf('パスワード') !== -1) {
        $(elem).find('input').attr('type', 'password');
      }
      pages.push($(elem).prop('outerHTML'));
    });

    return pages;
  }

  get_text(page) {
    // let ttl;
    const ttl = $(page)
      .find('th')
      .html()
      .replace(/<span>必須<\/span>/g, '')
      .replace(/ /g, '')
      .trim();
    return ttl;
  }

  get_tpl(page) {
    const ttl = $(page)
      .find('th')
      .html()
      .replace(/<span>必須<\/span>/g, '')
      .replace(/ /g, '')
      .trim();

    if (ttl !== '' && ttl.indexOf('住所') !== -1) {
      return 'set-retro-adress';
    }

    // if (ttl !== '' && ttl.indexOf('希望日') !== -1) {
    //   return 'set-calendar';
    // }
    return 'set-base';
  }

  get_inputs(page) {
    // 案件ごとに子クラスで上書きをする
    const inputs = [];
    const obj = $(page).find('input,select,textarea');
    for (let index = 0; obj.length > index; index++) {
      inputs.push(obj[index]);
    }

    return inputs;
  }

  get_required(page) {
    const ttl = $(page).find('th').html();
    let flag = 0;
    if (ttl.indexOf('必須') !== -1) {
      flag = 1;
    }

    return flag;
  }

  get_attr(page, inputs, index, tempanswer) {
    const question = $(page)
      .find('th')
      .html()
      .replace(/<span>必須<\/span>/g, '')
      .replace(/ /g, '')
      .trim();

    // 自動フリガナ用の属性を設定
    if (question.indexOf('お名前') !== -1) {
      if (question.indexOf('カナ') !== -1) {
        // フリガナ
        tempanswer['data-input'] = 'output';
        tempanswer['validate-type'] = ['char', 'kana', 'seimei'];
      } else {
        // お名前
        tempanswer['data-input'] = 'input';
        tempanswer['validate-type'] = ['char', 'seimei'];
      }
    }

    // ダンボールの場合
    if (tempanswer.name === 'danball') {
      const val = tempanswer.value;

      tempanswer.value = [];
      for (let i = 0; val.length > i; i++) {
        const obj = {};
        obj.val = val[i][Object.keys(val[i])];
        obj.img = $(page).find('.txt_radio').find('img').eq(i).attr('src');
        obj.text = $(page).find('.txt_radio').find('p').eq(i).html();
        tempanswer.value.push(obj);
      }
    }

    if (tempanswer.type === 'date') {
      tempanswer.readonly = 'readonly';
    }

    if ($(inputs[index]).attr('placeholder')) {
      tempanswer.placeholder = $(inputs[index]).attr('placeholder');
    }
  }

  get_free_text(page, temp) {
    // 追加テキストを取得
    const text = $(page).find('.txt_ss')[0];
    temp.add = {'free-txt': $(text).text().trim()};
  }

  /**
   * JSONデータを編集する
   * @param data 読み込んだデータ
   * @returns 編集したデータ
   */
  edit(data, formQuery) {
    super.edit(data, formQuery);

    const kiyaku = {
      'set-base': {
        question: '個人情報の取り扱いについて',
        answer: [
          {
            type: 'checkbox',
            name: 'doui',
            'data-required': '1',
            value: [
              {
                1: '同意する',
              },
            ],
          },
        ],
        add: {
          'free-txt':
            "個人情報の取り扱いについては、以下リンクに記載されているプライバシーポリシーを遵守します。<br>「同意する」にチェックを付け、お申込み内容をご入力ください。<br><br><a class='policy_icon' href='https://itaku.retro.jp/policy/' target='_brank'>プライバシーポリシーを読む<span></span></a>",
        },
      },
    };

    data.form.label.push(kiyaku);

    return data;
  }
}
